import type { TPageTranslations } from '@crehana/i18n';

import { DIPLOMAS_TRANSLATION_KEY } from '../constants';
import type { DiplomasLocaleKeys } from '../types';

const en: TPageTranslations<
  DiplomasLocaleKeys,
  typeof DIPLOMAS_TRANSLATION_KEY
> = {
  [DIPLOMAS_TRANSLATION_KEY]: {
    // Empty view
    EMPTY_VIEW_TITLE: "You haven't earned a diploma yet",
    EMPTY_VIEW_DESC:
      'Once you complete 100% of your courses or your projects are approved, you will be able to obtain your diplomas.',
    EMPTY_VIEW_BUTTON: 'Go to my projects',
    EMPTY_VIEW_DEGREE_DESC:
      'Once you complete all the courses and submit your partial projects, you will need to advance your final project and pass it in order to obtain your MicroDegree diploma.',
    EMPTY_VIEW_DEGREE_BUTTON: 'Go to my MicroDegree',
    EMPTY_VIEW_BUTTON_USER_HE: 'Go to my paths',
    // Error view
    DIPLOMAS_ERROR: 'An error occurred while retrieving your diplomas',
    GENERAL_ERROR: 'An error occurred',
    TRY_AGAIN: 'Try again',
    INTERNET_CONNECTION_ERROR: 'A connection error occurred',
    RELOAD_PAGE: 'Reload the page',
    CERTIFICATE: 'CERTIFICATE',
    TRACK: 'TRACK',
    CONSTANCE: 'CONSTANCE',
  },
};

export default en;
